import { anyPass, isEmpty, isNil, reject } from 'ramda';

/**
 * 주어진 객체에서 `nil`이거나 비어있는(`isEmpty() -> true`) 값을 제외한 새로운 객체를 반환한다.
 */
export const rejectNilKeys = reject(anyPass([isNil, isEmpty]));
